module.exports = __webpack_public_path__ + "img/animation.c099fd61.svg";